import { render, staticRenderFns } from "./PortalFilterBar.vue?vue&type=template&id=39d43cf6&scoped=true&"
import script from "./PortalFilterBar.vue?vue&type=script&lang=js&"
export * from "./PortalFilterBar.vue?vue&type=script&lang=js&"
import style0 from "./PortalFilterBar.vue?vue&type=style&index=0&id=39d43cf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d43cf6",
  null
  
)

export default component.exports